import type { DirectiveBinding } from 'vue';

function shouldCreateTooltipsWrapper() {
  const isThereATooltipsWrapper =
    document.body.querySelector('#cactusTooltipWrap');

  if (isThereATooltipsWrapper) return;

  const tooltipsWrapper = document.createElement('div');
  const tooltip = document.createElement('span');

  tooltipsWrapper.setAttribute('id', 'cactusTooltipWrap');
  tooltip.setAttribute('id', 'cactusTooltip');
  tooltip.classList.add(`tooltip`);
  tooltipsWrapper.appendChild(tooltip);

  document.body.appendChild(tooltipsWrapper);
}

export default defineNuxtPlugin((nuxtApp: any) => {
  let tooltipDirective;

  if (!import.meta.client) {
    tooltipDirective = {
      mounted() {},
    };
  } else {
    tooltipDirective = {
      mounted(el: HTMLElement, binding: DirectiveBinding) {
        const { isMobile, isSidebarMenuOpen } = useLayout();

        el.classList.add('relative');
        shouldCreateTooltipsWrapper();

        const tooltip = document.getElementById('cactusTooltip');

        el.addEventListener('mouseenter', () => {
          if (
            tooltip === null ||
            !binding.value ||
            (binding.modifiers?.desktopOnly && isMobile.value) ||
            (binding.modifiers?.closedSideBarOnly && isSidebarMenuOpen.value)
          ) {
            return;
          }

          const rect = el?.getBoundingClientRect();

          const arrowMargin = 22;

          if (binding.modifiers?.bottom) {
            tooltip.style.top = `${rect.bottom + window.scrollY + rect.height}px`;
            tooltip.classList.add('tooltip-bottom');
          } else {
            tooltip.style.top = `${rect.top + window.scrollY + rect.height / 4}px`;
          }
          if (binding.modifiers?.padding) {
            tooltip.style.top = `${rect.bottom + window.scrollY}px`;
          }
          if (binding.modifiers?.left) {
            tooltip.style.left = `${rect.left + window.scrollX + rect.width / 2 + arrowMargin}px`;
            tooltip.classList.add(`tooltip-left`);
          } else {
            tooltip.style.left = `${rect.left + window.scrollX + rect.width + 8}px`;
            tooltip.classList.add('tooltip-right');
          }
          if (binding.modifiers?.noArrow) {
            tooltip.classList.add('no-arrow');
          }
          if (binding.value.length > 25) {
            tooltip.classList.add('min-width');
          }

          tooltip.textContent = binding.value;
          tooltip.classList.add('block', 'opacity-100');
        });

        function hideTooltip() {
          tooltip?.classList.remove(
            'block',
            'opacity-100',
            'tooltip-left',
            'tooltip-right',
            'tooltip-bottom',
            'no-arrow',
            'min-width',
          );
        }

        el.addEventListener('mouseleave', hideTooltip);
        el.addEventListener('wheel', hideTooltip, { passive: true });
        el.addEventListener('click', hideTooltip);
      },
    };
  }

  nuxtApp.vueApp.directive('tooltip', tooltipDirective);
});
